import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const DetailAddonInfoPromo = styled.div<React.CSSProperties>`
  font-family: ${Fonts['bold']};
  color: ${Colors['promo']};
  font-size: ${Screen.widthRatio * 32}px;
  margin-top: ${Screen.widthRatio * 12}px;
  margin-left: ${Screen.widthRatio * 60}px;
`;

export default DetailAddonInfoPromo;
